import axios from 'axios';
import { format } from 'date-fns';
import { SET_ERROR, GET_PAYROLL_DETAIL, GET_CERTIFIED_JOB_CC } from "../../types";
import ToastMessage from '../../../components/toast';

export async function getCPReport(company, payrollId, runBy, tableTemplate, costCenterId, startDate, endDate, selectedReport) {
    startDate = format(startDate, "yyyy-MM-dd")
    endDate = format(endDate, "yyyy-MM-dd")
    return axios.get('api/certified-payroll/certified-payroll-new', {
        params: { company, payrollId, runBy, tableTemplate, costCenterId, startDate, endDate, selectedReport },
        responseType: 'arraybuffer'
    }).catch(er => {
        ToastMessage("Error Processing data", "error");
    });
};

export const payrollDetailAction = (company, { includeUnfinalized, startDate, payrollType, addNumberDays }) => {
    return async (dispatch) => {
        await axios.get(`api/payroll/get-payroll/${company}`, {
            params: {
                includeUnfinalized,
                startDate,
                payrollType,
                addNumberDays
            }
        }).then(response => {
            dispatch({
                type: GET_PAYROLL_DETAIL,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            });
        });
    };
};


export const CertifiedJobCC = (companyShortName, certifiedJobField, costCenterTreeName) => {
    return async dispatch => {
        await axios.get('api/certified-payroll/job-cost-centers', {
            params: {
                companyShortName,
                certifiedJobField,
                costCenterTreeName
            }
        }).then(res => {
            dispatch({
                type: GET_CERTIFIED_JOB_CC,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};